module.exports = __webpack_public_path__ + "static/img/01.7bab1fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/k_mueller/01.jpg
// module id = 408
// module chunks = 1